export default __webpack_public_path__ + "../staticImages/packster-der-verpackungsshop.png";